import { AppData } from '@lightningjs/sdk';
import { AppInstance } from '@lightningjs/sdk/src/Application';

/**
 * Calls the augmented Application's close app function.
 */
export const closeApp = () => {
  (AppInstance?.application as any)?.closeApp();
};

export const shouldUseDevAccessHeader = () => {
  const isProduction = AppData?.isProduction;
  const { header, key } = AppData?.devAccessHeader ?? {};
  return !isProduction && !!header && !!key;
};

/**
 * Simple deep merge with two object
 */
export const deepMerge = <
  T extends Record<string, any>,
  U extends Record<string, any>,
>(
  baseObj: T,
  mergeObj: U,
): T & U => {
  const result = { ...baseObj };

  for (const key in mergeObj) {
    if (isObject(mergeObj[key])) {
      if (isObject(result[key])) {
        result[key] = deepMerge(result[key], mergeObj[key]);
      } else {
        result[key] = deepMerge<any, any>({}, mergeObj[key]);
      }
    } else {
      result[key] = mergeObj[key] as any;
    }
  }

  return result as T & U;
};

const isObject = (item: any): item is Record<string, any> =>
  item && typeof item === 'object' && !Array.isArray(item);
